var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"label":"Número de transferencia"},model:{value:(_vm.authorizationCode),callback:function ($$v) {_vm.authorizationCode=$$v},expression:"authorizationCode"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }